import React from "react";
import { useTranslation } from "react-i18next";
import './Page.css';
import './Nagrania.css';


function Nagrania() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-container">
        <div className="page-header">
          <h1>{t('recordings.title')}</h1>
          <p className="page-subtitle">{t('recordings.subtitle')}</p>
        </div>
        
        <div className="page-content">
          <div className="recordings-intro">
            <p>
              {t('recordings.intro')}
            </p>
          </div>

          <div className="youtube-recordings-section">
            <h2 className="youtube-section-title">{t('recordings.videoRecordings')}</h2>
            <div className="youtube-recordings">
              <div className="youtube-video-container">
              <div className="youtube-video-wrapper">
                <iframe
                  className="youtube-iframe"
                  src="https://www.youtube.com/embed/9LYd9lMxPtc"
                  title="Recording 1"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div className="youtube-video-container">
              <div className="youtube-video-wrapper">
                <iframe
                  className="youtube-iframe"
                  src="https://www.youtube.com/embed/BgGDkAUKhNA"
                  title="Recording 2"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            </div>
          </div>

          {/* <div className="recordings-list">
            {recordings.map((recording) => (
              <div key={recording.id} className="recording-card">
                <div className="recording-header">
                  <div className="recording-cover">
                    <img 
                      src={recording.cover} 
                      alt={recording.title}
                      className="cover-image"
                    />
                    <div className="recording-type">{recording.type}</div>
                  </div>
                  <div className="recording-info">
                    <h3 className="recording-title">{recording.title}</h3>
                    <div className="recording-meta">
                      <span className="recording-year">{recording.year}</span>
                      <span className="recording-type-badge">{recording.type}</span>
                    </div>
                    <p className="recording-description">{recording.description}</p>
                  </div>
                </div>
                
                <div className="tracks-list">
                  <h4>{t('recordings.tracks')}:</h4>
                  {recording.tracks.map((track) => (
                    <div 
                      key={track.id} 
                      className={`track-item ${playingTrack === track.id ? 'playing' : ''}`}
                    >
                      <div className="track-info">
                        <div className="track-title">{track.title}</div>
                        <div className="track-description">{track.description}</div>
                      </div>
                      <div className="track-controls">
                        <span className="track-duration">{track.duration}</span>
                        <button 
                          className="play-button"
                          onClick={() => playTrack(track.id)}
                        >
                          {playingTrack === track.id ? t('common.pause') : t('common.play')}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div> */}

          {/* <div className="streaming-info">
            <h3>{t('recordings.streaming')}</h3>
            <div className="streaming-platforms">
              <div className="platform">
                <div className="platform-icon">🎵</div>
                <div className="platform-name">Spotify</div>
              </div>
              <div className="platform">
                <div className="platform-icon">🎧</div>
                <div className="platform-name">Apple Music</div>
              </div>
              <div className="platform">
                <div className="platform-icon">▶️</div>
                <div className="platform-name">YouTube Music</div>
              </div>
              <div className="platform">
                <div className="platform-icon">🎼</div>
                <div className="platform-name">Tidal</div>
              </div>
            </div>
            <p className="streaming-note">
              {t('recordings.streamingNote')}
            </p>
          </div>

          <div className="upcoming-recordings">
            <h3>{t('recordings.upcoming')}</h3>
            <div className="upcoming-item">
              <h4>{t('recordings.wagner')}</h4>
              <p>{t('recordings.wagnerDesc')}</p>
            </div>
            <div className="upcoming-item">
              <h4>{t('recordings.duets')}</h4>
              <p>{t('recordings.duetsDesc')}</p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Nagrania;
